import { Button } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { ClassPost_ClassPostFragment } from "@outschool/ui-components-classroom";
import React from "react";

interface SeeMoreCommentsLinkProps {
  post: ClassPost_ClassPostFragment;
  onClick: () => void;
}

export default function ({ post, onClick }: SeeMoreCommentsLinkProps) {
  const { t } = useTranslation(
    "client\\components\\classroom\\SeeMoreCommentsLink",
  );
  const remainingCommentsCount = post.commentsPreview?.remainingCommentsCount;
  return remainingCommentsCount > 0 ? (
    <Button
      variant="link"
      onClick={onClick}
      sx={{
        mb: "1em",
      }}
    >
      {t("See {{remainingCommentsCount}} more comment", {
        remainingCommentsCount,
        count: remainingCommentsCount,
        defaultValue_plural: "See {{remainingCommentsCount}} more comments",
      })}
    </Button>
  ) : null;
}
